import React, { Component } from 'react';
import { render } from 'react-dom';
import { connect } from 'react-redux';
import { popupShow, popupReposition, popupPosition, popupHide, popupUnsetParentRef } from '~/store/actions/popup';

const popupDecorator = (Wrapped) => {
  @connect(
    ({ popup: __POPUP__ }) => ({ __POPUP__ }),
    (dispatch) => ({
      __POPUP_ACTIONS__: {
        popupShow: (...args) => dispatch(popupShow(...args)),
        popupReposition: (...args) => dispatch(popupReposition(...args)),
        popupPosition: (...args) => dispatch(popupPosition(...args)),
        popupHide: (...args) => dispatch(popupHide(...args)),
        popupUnsetParentRef: (...args) => dispatch(popupUnsetParentRef(...args)),
      },
    }),
  )
  class PopupWrapper extends Component {
    onResized = () => {
      const {
        __POPUP_ACTIONS__: { popupReposition },
      } = this.props;

      setTimeout(popupReposition, 300);
    };

    onMouseDown = () => {
      const {
        __POPUP_ACTIONS__: { popupHide },
      } = this.props;

      popupHide();
    };

    // eslint-disable-next-line react/no-deprecated
    componentWillMount() {
      window.addEventListener('mousedown', this.onMouseDown, false);
      window.addEventListener('touchstart', this.onMouseDown, false);

      window.addEventListener('resize', this.onResized, false);
      window.addEventListener('orientationchange', this.onResized, false);
    }

    componentWillUnmount() {
      const {
        __POPUP_ACTIONS__: { popupHide, popupUnsetParentRef },
      } = this.props;

      popupHide();
      popupUnsetParentRef();

      window.removeEventListener('mousedown', this.onMouseDown);
      window.removeEventListener('touchstart', this.onMouseDown);

      window.removeEventListener('resize', this.onResized);
      window.removeEventListener('orientationchange', this.onResized);
    }

    firstShowDone = false;

    render() {
      const {
        __POPUP__: { show, ref, id: shownId },
        __POPUP_ACTIONS__: { popupShow, popupHide, popupPosition },
        ...props
      } = this.props;

      return (
        <Wrapped
          popupShow={(id, element, content) => {
            if (!id || !element || !content) {
              throw Error('all parameters are required');
            }

            if (!ref) {
              if (process.env === 'debug') {
                throw Error('rendered Popup component is missing');
              }

              return;
            }

            if (show && shownId === id) {
              return popupHide();
            }

            render(content, ref);

            if (this.firstShowDone) {
              popupPosition(element);
              popupShow(id);
              return;
            }

            setTimeout(() => {
              popupPosition(element);
              popupShow(id);
            }, 100);

            this.firstShowDone = true;
          }}
          popupHide={popupHide}
          popupVisible={show}
          {...props}
        />
      );
    }
  }

  PopupWrapper.displayName = `popup(${Wrapped.displayName || Wrapped.name || 'Component'})`;

  return PopupWrapper;
};

export default popupDecorator;
